import { parseISO } from 'date-fns';
import { parse } from './Duration';

function isNumber(value: string) {
    return /^\d+$/.test(value);
}

function isCalendarMonth(value: string) {
    return /^([0-9]{4})-(1[0-2]|0[1-9])$/.test(value);
}

function isOrdinalYear(value: string) {
    return /^([0-9]{2,4}) [-:TWZ]/.test(value);
}

function isCronString(value: string) {
    return /^[0-9*\/]+ [0-9*\/]+ [0-9*\/]+ ?/.test(value);
}

export function ReviveDateTime(key: any, value: any): any {
    if (typeof value == 'string') {
        if (!isNumber(value) && !isCalendarMonth(value) && !isOrdinalYear(value) && !isCronString(value)) {
            const date = parseISO(value);
            if (!isNaN(date.valueOf())) return date;
        }

        const duration = parse(value);
        if (!isNaN(duration.valueOf())) return duration;

        return value;
    }

    return value;
}
